import { setIntersectionObserver } from "../utils/observers";
import { $Q, $Qll } from "../utils/query-selector";

/**
 * Evaluates if is located in product page
 * and proceed to check window size
 */
export const stickyCart = () => {
  if(typeof window === 'undefined') return;
  if(!window.location.pathname.includes('product') || !window.location.pathname.includes('pages')) return;

  checkWindowSize();
}

/**
 * Adds load and resize event listeners and
 * executes scroll event
 */
const checkWindowSize = () => {
  window.addEventListener('load', () => {
    setScrollEvent();
  });
  window.addEventListener('resize', () => {
    setScrollEvent();
  });
}

/**
 * Sets scroll event and reads window width
 */
const setScrollEvent = () => {
  window.addEventListener('scroll', () => {
    const stickyCart = $Q('.sticky-cart');

    if(!stickyCart) return;

    if(window.innerWidth > 991) {
      stickyCartDesktop(stickyCart);
    } else {
      stickyCartMobile(stickyCart);
    }
  })
}

/**
 * Hides or shows the sticky cart depending
 * on scroll distance
 * @param {HTMLElement} stickyCart
 */
const stickyCartDesktop = (stickyCart) => {
  if(window.scrollY > 150 ) {
    stickyCart.classList.remove('not-sticky');
  } else {
    stickyCart.classList.add('not-sticky');
  }
}

/**
 * Hides or shows the sticky cart depending
 * on scroll distance and surpassing button
 * @param {HTMLElement} stickyCart
 */
const stickyCartMobile = (stickyCart) => {
  const mainSection = $Q('.main-product');
  const button = $Q('.btn-add-to-cart', mainSection);
  const buttonsOffset = button.offsetTop;
 

  if(!button) return;

  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0
  }

  setIntersectionObserver(options, button);

  if(
    !window.isIntersecting
    && window.isIntersecting !== undefined
    && window.scrollY > buttonsOffset
  ) {
    stickyCart.classList.remove('not-sticky');
  } else {
    stickyCart.classList.add('not-sticky');
  }
}

/**
 * Synchronizes sticky price
 */
export const syncStickyPrice = () => {
  const subscriptions = $Q('.main-product__subscriptions');
  const stickyPrice = $Q('.sticky-cart__price');

  if(!subscriptions) {
    setStickySubscriptionPrice(null, stickyPrice);
  } else {
    setStickySubscriptionPrice(subscriptions, stickyPrice);
  }
}

/**
 * Set the sticky price based on main product price from subscriptions
 * @param {Document} parent - It is the parent in DOM
 * @param {HTMLElement} stickyPrice - It is the sticky price element
 */
const setStickySubscriptionPrice = (parent, stickyPrice) => {
  const baseQuery = '.main-product__subscriptions';
  const subscriptionWrapper = $Q(
    `${baseQuery}-wrapper[data-active="true"]`,
    parent);
  let mainPrice = $Q(
    `${baseQuery}-price`,
    parent ? subscriptionWrapper : null);
    if (!mainPrice) {
      mainPrice = $Q(
        `${baseQuery}-discount-price`,
        parent ? subscriptionWrapper : null);
    }
  if(!stickyPrice || !mainPrice) return;
    stickyPrice.innerText = mainPrice.innerText.trim();

  setVariantPrice(mainPrice);
}

/**
 * It assigns the price to button add to cart
 * @param {HTMLElement} mainPrice - Element with price
 */
const setVariantPrice = (mainPrice) => {
  const variantPrice = $Qll('#variant-price');

  if(!variantPrice) return;

  variantPrice.forEach(price => {
    price.innerText = `${mainPrice.innerText.trim()}`;
  })
}
